import { render, staticRenderFns } from "./CreatePickupLocation.vue?vue&type=template&id=00ea4750"
import script from "./CreatePickupLocation.vue?vue&type=script&lang=js"
export * from "./CreatePickupLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports